import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";
import { useLazyGetCmsQuery, useLazyGetFaqQuery } from "../../service/main";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";

const FAQs = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [getFaq] = useLazyGetFaqQuery();
  const [loading, setLoading] = useState(false);
  const [faqData, setFaqData] = useState<
    { question: string; answer: string; id: string }[]
  >([]);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await getFaq({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setFaqData(response?.data?.data);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1>FAQs</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          FAQs
        </p>
      </div>
      <div className="cards">
        <section className="home_faq_sc u_spc">
          <div className="container">
            <div className="s_head text_center hd_4">
              <p>
                Frequently Asked Questions help you get quick answers about your
                orders, payments, shipping, and more.
                <span className="d_block">Find solutions easily below.</span>
              </p>
            </div>
            {faqData?.length > 0 ? (
              <div className="faq_lst hd_7">
                {faqData?.map((item, index) => (
                  <Accordion
                    key={index}
                    expanded={expanded === item.id}
                    onChange={handleChange(item.id)}
                    className="faq_bx"
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <h3>{item.question}</h3>
                    </AccordionSummary>
                    <AccordionDetails>{item.answer}</AccordionDetails>
                  </Accordion>
                ))}
              </div>
            ) : (
              <div>
                <h3>No Data Found</h3>
              </div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default FAQs;
